package com.exura.features.plandefinition.domain.builder.series

import com.exura.features.plandefinition.domain.builder.PlanElementBuilder
import com.exura.features.plandefinition.domain.builder.BuilderField
import com.exura.features.plandefinition.domain.model.element.BasePlanElement
import com.exura.features.plandefinition.domain.model.series.BaseSeries
import com.exura.features.plandefinition.domain.model.series.SeriesSpawnType

abstract class BaseSeriesBuilder<E: BasePlanElement, T : BaseSeries<out E>>(
    val seriesType: SeriesSpawnType,
) : PlanElementBuilder<T> {

    private val firebaseDocId = BuilderField<String?>()
    private val name = BuilderField<String>(isRequired = true)
    private val description = BuilderField<String>(default = "")
    private val imageUrl = BuilderField<String?>()

    private var cachedElements: List<E>? = null
    private var elementsNeedRecalculation: Boolean = true

    override var cachedBuildResult: T? = null
    override var buildResultNeedRecalculation: Boolean = true

    override var isChanged: Boolean = false

    fun firebaseDocId(): String? = firebaseDocId.getValue()
    fun setFirebaseDocId(newValue: String?) = apply {
        val res = firebaseDocId.setValue(newValue)
        updateChangedState(res)
    }
    fun name(): String? = name.getValue()
    fun setName(newValue: String) = apply {
        val res = name.setValue(newValue)
        updateChangedState(res)
        updateBuildState(res)
    }
    fun description(): String? = description.getValue()
    fun setDescription(newValue: String) = apply {
        val res = description.setValue(newValue)
        updateChangedState(res)
        updateBuildState(res)
    }
    fun imageUrl(): String? = imageUrl.getValue()
    fun setImageUrl(newValue: String?) = apply {
        val res = imageUrl.setValue(newValue)
        updateChangedState(res)
        updateBuildState(res)
    }

    override fun validate(): List<String> {
        val fields = mapOf(
            "name" to name,
            "description" to description,
            "imageUrl" to imageUrl,
            "firebaseDocId" to firebaseDocId,
        )
        val messages = validateFields(fields)
       return messages
    }

    override fun markSaved() = apply {
        firebaseDocId.markSaved()
        name.markSaved()
        description.markSaved()
        imageUrl.markSaved()

        super.markSaved()
    }


    fun elements(): List<E> {
        return if (elementsNeedRecalculation || cachedElements == null) {
            cachedElements = rebuild().spawnElements()
            elementsNeedRecalculation = false
            cachedElements!!
        } else {
            cachedElements!!
        }
    }


    fun updateElementsCalculationState(setResult: Boolean) {
        elementsNeedRecalculation = elementsNeedRecalculation || setResult
    }

}
